import React, { useState, useImperativeHandle, forwardRef } from 'react';
import StepOneForm from '../../component/shared/shipment-calculator/StepOneForm';
import StepTwoForm from '../../component/shared/shipment-calculator/StepTwoForm';

const ShipmentCalcForm = forwardRef(({ currentForm, formData, setFormData, loadType }, ref) => {
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleDateChange = (date) => {
    setFormData(prev => ({ ...prev, shipmentDate: date }));
    setErrors(prev => ({ ...prev, shipmentDate: '' }));
  };

  const validateStep = () => {
    let tempErrors = {};
    if (currentForm === 1) {
      if (!formData.shipmentDate) tempErrors.shipmentDate = 'Shipment date is required';
      if (!formData.originCountry) tempErrors.originCountry = 'Origin country is required';
      if (!formData.originPort) tempErrors.originPort = 'Origin port is required';
      if (!formData.destinationCountry) tempErrors.destinationCountry = 'Destination country is required';
      if (!formData.destinationPort) tempErrors.destinationPort = 'Destination port is required';
    } else if (currentForm === 2) {
      if (!formData.commodity) tempErrors.commodity = 'Commodity is required';
      if (!formData.containerType) tempErrors.containerType = 'Container type is required';
      if (!formData.unit || isNaN(formData.unit) || Number(formData.unit) <= 0) tempErrors.unit = 'Valid unit count is required';
      if (!formData.length || isNaN(formData.length) || Number(formData.length) <= 0) tempErrors.length = 'Valid length is required';
      if (!formData.width || isNaN(formData.width) || Number(formData.width) <= 0) tempErrors.width = 'Valid width is required';
      if (!formData.height || isNaN(formData.height) || Number(formData.height) <= 0) tempErrors.height = 'Valid height is required';
      if (!formData.grossWeight || isNaN(formData.grossWeight) || Number(formData.grossWeight) <= 0) tempErrors.grossWeight = 'Valid gross weight is required';
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  useImperativeHandle(ref, () => ({
    validateCurrentStep: () => validateStep(),
    resetErrors: () => setErrors({})
  }));

  return (
    <form>
      {currentForm === 1 && (
        <StepOneForm
          formData={formData}
          setFormData={setFormData}
          handleChange={handleChange}
          handleDateChange={handleDateChange}
          errors={errors}
          setErrors={setErrors}
          loadType={loadType}
        />
      )}
      {currentForm === 2 && (
        <StepTwoForm
          formData={formData}
          handleChange={handleChange}
          errors={errors}
          setFormData={setFormData}
          setErrors={setErrors}
        />
      )}
    </form>
  );
});

export default ShipmentCalcForm;
